import { DateTime } from 'luxon';

import CONSTANTS from '@/helpers/constants';

export function convertDateTimeFromUtcToLocal(
  value: string | undefined | null,
  format: string | undefined,
): string | undefined {
  switch (value) {
    case CONSTANTS.DATA_VALUES.DEFAULT_STRING:
      return '';

    case undefined:
    case '':
    case null:
      return undefined;

    default: {
      const dateTime = DateTime.fromISO(value, { zone: 'utc' }).toLocal();
      if (!dateTime.isValid) return undefined;
      // If no format provided, return ISO string; otherwise return formatted string
      return format ? dateTime.toFormat(format) : dateTime.toUTC().toISO();
    }
  }
}
